import { LoadingImageProps } from '@/types/props/components';
import LoadingComponent from './LoadingComponent';

export default function LoadingImage({
  loading,
  className,
  children,
}: LoadingImageProps) {
  if (loading) {
    return (
      <LoadingComponent
        as={'div'}
        componentProps={{
          className: className,
        }}
        loading={true}
      >
        <span
          className="tw-w-full tw-h-full tw-block"
          aria-label="loading image..."
        ></span>
      </LoadingComponent>
    );
  }
  return children;
}
